import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  key: 1,
  class: ""
};
const _hoisted_2 = {
  class: "flex justify-between"
};
const _hoisted_3 = {
  key: 0,
  class: "btn-group pull-right dropdown"
};
const _hoisted_4 = {
  class: "dropdown-menu"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  class: "tw"
};
const _hoisted_7 = {
  class: "my-1"
};
const _hoisted_8 = {
  class: "w-full bg-[rgba(var(--v-theme-error),0.08)] text-center text-base px-2 py-2 rounded-md"
};
const _hoisted_9 = {
  class: "flex py-2"
};
const _hoisted_10 = {
  class: "w-4/12 pl-2"
};
const _hoisted_11 = {
  key: 0,
  class: "py-2",
  "data-cy": "client-matter-div"
};
const _hoisted_12 = {
  key: 1,
  class: "py-2"
};
const _hoisted_13 = {
  class: "flex py-2"
};
const _hoisted_14 = {
  key: 0,
  class: "w-6/12 pl-2"
};
const _hoisted_15 = {
  class: "h-full pl-2"
};
const _hoisted_16 = {
  key: 2,
  class: "py-2"
};
const _hoisted_17 = {
  key: 3,
  class: "py-2 pl-2 border-l-4 rounded border-green-regular/25 bg-green-regular/[0.04]"
};
const _hoisted_18 = {
  class: "py-1"
};
const _hoisted_19 = {
  key: 0,
  class: "pt-1"
};
const _hoisted_20 = {
  key: 1,
  class: "pt-2"
};
const _hoisted_21 = {
  class: "flex gap-2 items-end"
};
const _hoisted_22 = {
  key: 0,
  class: "py-1"
};
const _hoisted_23 = {
  key: 1,
  class: "py-1",
  "data-cy": "warning-no-sync-account"
};
const _hoisted_24 = {
  key: 4,
  class: "py-2 pl-2 border-l-4 rounded border-green-regular/25 bg-green-regular/[0.04]"
};
const _hoisted_25 = {
  key: 0,
  class: "py-1"
};
const _hoisted_26 = {
  class: "py-1"
};
const _hoisted_27 = {
  key: 1,
  class: "py-1"
};
const _hoisted_28 = {
  class: "py-1"
};
const _hoisted_29 = {
  class: "text-xs text-gray-500"
};
const _hoisted_30 = {
  key: 2,
  class: "py-1",
  "data-cy": "warning-no-bank-account"
};
const _hoisted_31 = {
  class: "w-full pt-2"
};
const _hoisted_32 = {
  class: "text-base"
};
const _hoisted_33 = {
  key: 5,
  class: "grid grid-cols-2 gap-x-4 mb-4"
};
const _hoisted_34 = {
  class: "grid grid-cols-2 gap-x-4"
};
const _hoisted_35 = {
  "data-replay-unmask": ""
};
const _hoisted_36 = {
  key: 0
};
const _hoisted_37 = {
  class: "flex pt-2"
};
const _hoisted_38 = {
  class: "py-2"
};
const _hoisted_39 = {
  class: "flex"
};
const _hoisted_40 = {
  class: "w-full"
};
const _hoisted_41 = {
  key: 0
};
const _hoisted_42 = {
  class: "py-1"
};
const _hoisted_43 = {
  class: "pt-4 pb-1"
};
const _hoisted_44 = {
  class: "flex justify-between pt-2"
};
const _hoisted_45 = {
  class: "fa fa-cog fa-spin ml-1"
};
const _hoisted_46 = {
  key: 8,
  class: "flex justify-between pt-4"
};
const _hoisted_47 = {
  class: "flex"
};
const _hoisted_48 = {
  class: "pr-4"
};
const _hoisted_49 = {
  class: "flex"
};
const _hoisted_50 = {
  class: "pr-4"
};
const _hoisted_51 = {
  class: "fa fa-cog fa-spin ml-1"
};
import { onMounted, reactive, computed, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useCodeStore } from '@/services/useCodeStore';
import { useCompanyStore } from '@/services/UserService/useCompanyStore';
import { useMeStore } from '@/services/UserService/useMeStore';
import { useAccountsStore } from '@/services/UserService/useAccountsStore';
import { useExpenseStore } from '@/services/useExpenseStore';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import { attachmentsToFileSelector } from '@/utils/attachmentsToFileSelector.js';
import { useAttachmentsStore } from '@/services/useAttachmentsStore';
import { useTrustAccountingStore } from '@/services/trustAccountingStore.js';
import RouteService from '@/services/RouteService';
import { useSupportChat } from '@/composables/useSupportChat';
import { resolveCostType } from '@/utils/expenseHelpers';
import ClientMatterSearch from '@/components/ClientMatterSearch.vue';
import LlSelect from '@/components/LlSelect.vue';
import ExpenseCodePicker from '@/components/ExpenseCodePicker.vue';
import LlTextField from '@/components/LlTextField.vue';
import LlDatePicker from '@/components/LlDatePicker.vue';
import MainHeader from '@/components/MainHeader.vue';
import UpgradeToProExpenseAttachmentsModals from '@/components/modals/UpgradeToProExpenseAttachmentsModals.vue';
import Loader from '@/components/Loader.vue';
import LlConfirmationDialog from '@/components/LlConfirmationDialog.vue';
import AttachmentPicker from '@/components/AttachmentPicker.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlCheckbox from '@/components/LlCheckbox.vue';
import LlWarningBanner from '@/components/LlWarningBanner.vue';
import FileChip from '@/components/FileChip.vue';
import MultipleAttachmentPreview from '@/components/MultipleAttachmentPreview.vue';
import useClientMatterStore from '@/services/useClientMatterStore';
const __default__ = {
  name: 'ExpenseEdit',
  uiView: 'edit'
};
export default /*@__PURE__*/Object.assign(__default__, {
  props: {
    stateParams: {
      type: Object,
      required: false,
      default: () => ({})
    },
    method: {
      type: String,
      required: false,
      default: ''
    },
    selectedExpense: {
      type: Object,
      required: false,
      default: () => ({})
    },
    leanLawApi: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    },
    selectedMatter: {
      type: String,
      required: false
    },
    tracking: {
      type: Object,
      required: true
    },
    methodOverride: {
      type: String,
      default: ''
    },
    /** When true: hides the client/matter selector (matter is pre-filled from selectedMatter) */
    settlementContext: {
      type: Boolean,
      default: false
    }
  },
  emits: ['filter', 'navigate-to-expenses'],
  setup(__props, {
    emit: __emit
  }) {
    const {
      getSupportUrl
    } = useSupportChat();

    // from components
    const props = __props;
    const codeStore = useCodeStore();
    const expenseStore = useExpenseStore();
    const accountsStore = useAccountsStore();
    const routeService = new RouteService(props);
    const companyStore = useCompanyStore();
    const attachmentsStore = useAttachmentsStore();
    const clientMatterStore = useClientMatterStore();
    const trustAccountingStore = useTrustAccountingStore();
    const {
      handleError,
      handleSuccess
    } = useSnackbarHandler();
    const {
      expenselist
    } = storeToRefs(useCodeStore());
    const {
      companySettings
    } = storeToRefs(useCompanyStore());
    const {
      features,
      permissions,
      me,
      terms
    } = storeToRefs(useMeStore());
    const {
      accountsList
    } = storeToRefs(useAccountsStore());
    const emit = __emit;
    const confirmDialog = ref(null);
    onMounted(async () => {
      editExpenseState.loading = true;
      await Promise.all([codeStore.expenseCodes(), accountsStore.listAccounts(), companyStore.loadMyCompany()]);
      loadAccounts();
      await loadExpenseForEdit();
      editExpenseState.loading = false;
    });
    const editExpenseState = reactive({
      loading: true,
      method: '',
      form: {
        id: undefined,
        billedState: undefined,
        client: {
          id: undefined,
          label: undefined
        },
        matter: {
          id: undefined,
          label: undefined
        },
        description: null,
        code: null,
        account: null,
        standard: null,
        date: null,
        accountingService: {
          service: {}
        },
        amount: null
      },
      cm: {},
      showAttachmentPreview: false,
      showUploadModal: false,
      deleteExistingAttachmentClicked: false,
      attachmentToDelete: {},
      accounts: [],
      okToClearDescription: false,
      saving: false,
      readonly: false,
      dropped: false,
      filesToUpload: [],
      fileSelector: [],
      selectedFileIndex: 0,
      showUpgradeToProExpenseAttachmentsModals: false,
      confirmationDialogText: '',
      costType: 'soft',
      billNumber: '',
      vendor: null,
      vendors: [],
      vendorLoading: false,
      showCreateVendor: false,
      newVendorName: '',
      bankAccountId: null,
      bankAccounts: [],
      bankAccountLoading: false,
      printLater: false,
      checkNumber: ''
    });
    const cmQueryFilter = computed(() => {
      const enableFlags = me.value.role === 'operator' || permissions.value.matters.autoAssign;
      return {
        scopeAccount: null,
        involved: !enableFlags,
        originating: false,
        reviewer: false,
        primary: false,
        archived: false
      };
    });
    const loadAccounts = () => {
      editExpenseState.accounts = accountsList.value.filter(x => x.id).filter(hasAssignPermission).sort((a, b) => a.name.localeCompare(b.name));
    };
    const hasAssignPermission = account => {
      if (!companySettings.value.permissions) {
        // new accounts don't have a permissions object
        return true;
      }
      const permission = companySettings.value.permissions.roles[account.role];
      if (permission?.expenses?.assignToExpense === undefined) {
        // backwards compatibility (assignToExpense is a new prop)
        return true;
      }
      return permission.expenses.assignToExpense;
    };
    const loadExpenseForEdit = async () => {
      const {
        expenseId
      } = props.stateParams;
      const {
        selectedExpense,
        selectedMatter
      } = props;
      if (expenseId || Object.keys(selectedExpense).length) {
        const expense = await expenseStore.getExpense({
          id: expenseId || selectedExpense.id
        });
        editExpenseState.form = {
          ...expense
        };
        editExpenseState.cm = JSON.parse(JSON.stringify(expense));
        if (expense.accounting?.type === 'Bill') {
          editExpenseState.costType = 'bill';
          if (expense.vendor) {
            editExpenseState.vendor = expense.vendor;
            editExpenseState.vendors = [expense.vendor];
          }
          editExpenseState.billNumber = expense.billNumber || '';
        } else if (expense.accounting?.type === 'Check') {
          editExpenseState.costType = 'check';
          if (expense.vendor) {
            editExpenseState.vendor = expense.vendor;
            editExpenseState.vendors = [expense.vendor];
          }
          editExpenseState.checkNumber = expense.checkNumber || '';
        }
        const code = editExpenseState.form.code;
        if (code) {
          editExpenseState.form.code = expenselist.value.find(({
            id
          }) => id === code.id);
        }
        editExpenseState.fileSelector = attachmentsToFileSelector(editExpenseState.form.attachments);
        checkDisabledUsersCase();
        await matterChanged();
      } else {
        if (selectedMatter) {
          editExpenseState.form.matter.id = selectedMatter;
          // matterChanged() gates on cm.matter.id — populate it here too, since the
          // client-matter-search picker (which normally sets cm) is hidden in settlement
          // context. Without this, form.matter never gets the fetched client.codes.ledes
          // that the Expense Code field's visibility depends on.
          editExpenseState.cm.matter = {
            id: selectedMatter
          };
          await matterChanged();
        }
        editExpenseState.form.date = new Date();
        const hardCostAvailable = features.value.uiHardCostCreation && permissions.value.expenses?.createHardCost && companySettings.value.expenses?.sync;
        editExpenseState.costType = hardCostAvailable ? resolveCostType(companySettings.value.expenses?.defaultCostType) : 'soft';
        if (editExpenseState.costType === 'bill' || editExpenseState.costType === 'check') {
          await loadVendors();
        }
        if (editExpenseState.costType === 'check') {
          await loadBankAccounts();
        }
        editExpenseState.okToClearDescription = true;
        // Filter out accountant role users for new expenses
        editExpenseState.accounts = editExpenseState.accounts.filter(({
          role
        }) => role !== 'accountant');

        // Preselect the current logged-in user for new expenses
        if (me.value?.id) {
          const currentUser = editExpenseState.accounts.find(account => account.id === me.value.id);
          if (currentUser) {
            editExpenseState.form.account = currentUser;
          }
        }
      }
    };
    function openSupportLink() {
      window.open(getSupportUrl('expenseAttachments'), '_blank', 'noopener,noreferrer');
    }
    function openInQuickbooks() {
      window.open(props.selectedExpense?.accounting.href, '_blank', 'noopener,noreferrer');
    }
    async function costTypeChanged() {
      if (editExpenseState.costType !== 'bill') {
        editExpenseState.billNumber = '';
      }
      if (editExpenseState.costType !== 'bill' && editExpenseState.costType !== 'check') {
        editExpenseState.vendor = null;
      }
      if (editExpenseState.costType !== 'check') {
        editExpenseState.bankAccountId = null;
        editExpenseState.printLater = false;
        editExpenseState.checkNumber = '';
      }
      if ((editExpenseState.costType === 'bill' || editExpenseState.costType === 'check') && !editExpenseState.vendors.length) {
        await loadVendors();
      }
      if (editExpenseState.costType === 'check' && !editExpenseState.bankAccounts.length) {
        await loadBankAccounts();
      }
    }
    function printLaterChanged(value) {
      editExpenseState.printLater = value;
      // Supplying a check number while deferring to QuickBooks' print queue doesn't mean
      // anything — don't leave a stale value sitting hidden behind the checkbox.
      if (value) {
        editExpenseState.checkNumber = '';
      }
    }
    async function loadVendors() {
      editExpenseState.vendorLoading = true;
      try {
        const result = await trustAccountingStore.accountingListVendors();
        editExpenseState.vendors = result || [];
      } catch {
        editExpenseState.vendors = [];
      } finally {
        editExpenseState.vendorLoading = false;
      }
    }
    async function loadBankAccounts() {
      editExpenseState.bankAccountLoading = true;
      try {
        const result = await trustAccountingStore.listAccountingAccounts({
          excludeTrust: true
        });
        editExpenseState.bankAccounts = result?.bank || [];
      } catch {
        editExpenseState.bankAccounts = [];
      } finally {
        editExpenseState.bankAccountLoading = false;
      }
    }
    async function createVendor() {
      const name = editExpenseState.newVendorName?.trim();
      if (!name) return;
      try {
        const newVendor = await trustAccountingStore.createVendor({
          displayName: name
        });
        editExpenseState.vendor = newVendor;
        editExpenseState.showCreateVendor = false;
        editExpenseState.newVendorName = '';
      } catch (e) {
        handleError(e);
      }
    }
    const handleSelectedAttachment = attachmentData => {
      const files = attachmentData;
      editExpenseState.fileSelector.unshift(...files);
      editExpenseState.filesToUpload.unshift(...files);
      editExpenseState.showAttachmentPreview = true;
    };
    function createExpenseTemplate(route) {
      routeService.go(route, {
        expense: editExpenseState.form
      });
    }
    function handelAddReceptClick() {
      if (!features.value.expenseAttachments) {
        editExpenseState.showUpgradeToProExpenseAttachmentsModals = true;
        return;
      }
      editExpenseState.showUploadModal = true;
    }
    function customFlagSelect(event) {
      editExpenseState.form.customFlag = !editExpenseState.form.customFlag;
      event.stopPropagation();
    }
    function selectedStandard() {
      if (!editExpenseState.form.standard) return;
      editExpenseState.form.description = editExpenseState.form.standard.description;
      editExpenseState.form.amount = editExpenseState.form.standard.amount;
      if (editExpenseState.form.standard.accounting) {
        editExpenseState.form.accountingService = editExpenseState.form.standard.accounting?.service;
      }
      if (editExpenseState.form.matter.client?.codes?.ledes && companySettings.value?.codes?.ledes) {
        editExpenseState.form.code = editExpenseState.form.standard.code;
      }
    }
    function checkDescription() {
      if (companySettings.value.codes?.populateDescriptions && (!editExpenseState.form.description || editExpenseState.okToClearDescription)) {
        editExpenseState.form.description = editExpenseState.form.code.label;
      }
    }
    async function matterChanged() {
      if (editExpenseState.cm?.matter?.id) {
        const matter = (await clientMatterStore.getMatterWithClientById(editExpenseState.cm.matter.id)) || {};
        editExpenseState.form.matter = JSON.parse(JSON.stringify(matter));
        editExpenseState.form.client = JSON.parse(JSON.stringify(editExpenseState.form.matter?.client));
      }
    }
    function handelDeleteAttachment(file) {
      if (!file.expenseAttachmentId) {
        clearAttachment(file);
        return;
      }
      editExpenseState.form.accounting ? handelDeleteConfirmationModel(file) : deleteExistingAttachment(file);
    }
    function clearAttachment(fileToRemove) {
      editExpenseState.fileSelector = editExpenseState.fileSelector.filter(file => file.id !== fileToRemove.id);
    }
    async function deleteExistingAttachment(fileToRemove) {
      try {
        await attachmentsStore.deleteExistingAttachment(fileToRemove);
        editExpenseState.fileSelector = editExpenseState.fileSelector.filter(file => file.expenseAttachmentId !== fileToRemove.expenseAttachmentId);
        editExpenseState.attachmentToDelete = {};
      } catch (error) {
        handleError('Unable to delete attachment');
      }
    }
    async function uploadAttachment(id) {
      if (!editExpenseState.fileSelector.length) return;
      const filesToUpload = editExpenseState.fileSelector.filter(file => !file.expenseAttachmentId);
      attachmentsStore.uploadAttachment(filesToUpload, id);
    }
    function confirmDeleteAttachment() {
      if (editExpenseState.deleteExistingAttachmentClicked) {
        deleteExistingAttachment(editExpenseState.attachmentToDelete);
        editExpenseState.deleteExistingAttachmentClicked = false;
        return;
      }
      editExpenseState.showUploadModal = true;
      editExpenseState.attachmentToDelete = {};
    }
    function handelDeleteConfirmationModel(fileToDelete) {
      editExpenseState.confirmationDialogText = 'Deleting, replacing, or adding an attachment to this expense will not alter the attachment(s) associated with the expense in QuickBooks.';
      editExpenseState.deleteExistingAttachmentClicked = true;
      editExpenseState.attachmentToDelete = fileToDelete;
      confirmDialog.value.open().then(result => {
        if (result) {
          confirmDeleteAttachment();
        } else {
          editExpenseState.showConfirmationDialog = false;
          editExpenseState.deleteExistingAttachmentClicked = false;
        }
      });
    }
    function back(reload) {
      if (props.stateParams.expenseId || props.stateParams.header) {
        const willReload = !props.state.includes('reports.generic');
        routeService.go('^', {}, {
          reload: willReload
        });
      }
      emit('filter', reload);
    }
    function deleteExpense() {
      editExpenseState.confirmationDialogText = props.selectedExpense?.accounting ? "Are you sure you don't want to bill this expense to a client?" : 'Are you sure you want to delete this expense? It cannot be undone.';
      confirmDialog.value.open().then(result => {
        if (result) {
          expenseStore.deleteExpense({
            id: editExpenseState.form.id
          }).then(() => {
            back(true);
          }).catch(err => {
            handleError(err);
          });
        }
      });
    }
    function markAsBilled() {
      editExpenseState.confirmationDialogText = "Are you sure you want to mark this expenses as billed? It won't be available for invoicing afterwards.";
      confirmDialog.value.open().then(result => {
        if (result) {
          editExpenseState.saving = true;
          props.leanLawApi.updateExpense({
            id: editExpenseState.form.id,
            body: {
              ...editExpenseState.form,
              billed: true
            }
          }).then(() => {
            handleSuccess('Expense was marked as billed');
            editExpenseState.saving = false;
            back(true);
          }).catch(err => {
            handleError(err);
            editExpenseState.saving = false;
          });
        }
      });
    }
    function checkDisabledUsersCase() {
      const {
        id
      } = editExpenseState.form.account || {};
      const user = editExpenseState.accounts.find(u => u.id === id);

      // Filter only valid accounts, skipping the 'disabled' and 'accountant' role accounts.
      editExpenseState.accounts = editExpenseState.accounts.filter(u => u.role !== 'accountant');

      // If the current user is 'disabled' or has the role of 'accountant' and is not in the list, add them back.
      if (user?.role === 'accountant') {
        if (!editExpenseState.accounts.find(a => a.id === id)) {
          editExpenseState.accounts.push(user);
        }
      }
      editExpenseState.readonly = !!editExpenseState.form.billed || !permissions.value.expenses.create;
    }
    function save(saveAndNew) {
      if (!editExpenseState.form.matter || !editExpenseState.form.matter.id) {
        return handleError(`${terms.value.matter} is required to record an Expense`);
      }
      if (!editExpenseState.form.date) {
        return handleError('Date is required to record an Expense');
      }
      if (companySettings.value.requireExpenseUser && !editExpenseState.form.account) {
        return handleError('Please select a User');
      }
      if (!editExpenseState.form.description) {
        return handleError('Description is required to record an Expense');
      }
      if (editExpenseState.form.amount === undefined || editExpenseState.form.amount === null) {
        return handleError('Amount is required to record an Expense');
      }
      if (editExpenseState.form.matter.client?.codes?.required?.expense && editExpenseState.form.matter.client?.codes?.ledes && companySettings.value?.codes?.ledes && !editExpenseState.form.code?.id) {
        return handleError('Code is required to record an Expense');
      }
      if (editExpenseState.costType === 'bill' && !editExpenseState.form.id) {
        if (!editExpenseState.vendor?.id) {
          return handleError('Select a vendor for this hard cost.');
        }
        if (!companySettings.value.expenses?.syncAccounts?.length) {
          return handleError('No expense posting account configured. Configure one in Settings > QuickBooks > Expenses.');
        }
      }
      if (editExpenseState.costType === 'check' && !editExpenseState.form.id) {
        if (!editExpenseState.bankAccountId) {
          return handleError('Select a bank account for this check.');
        }
      }
      if (!editExpenseState.form.matter.client?.codes?.ledes && companySettings.value?.codes?.ledes) {
        editExpenseState.form.code = {};
      }
      if (!features.value.qboFixedFeeAndExpenseMapping || !editExpenseState.form.accountingService) {
        editExpenseState.form.accountingService = {};
      }
      editExpenseState.saving = true;
      if (editExpenseState.form.id) {
        if (!editExpenseState.form.account) {
          // necessary to remove an account if one was selected before update
          editExpenseState.form.account = {};
        }
        props.leanLawApi.updateExpense({
          id: editExpenseState.form.id,
          body: editExpenseState.form
        }).then(async expense => {
          if (editExpenseState.filesToUpload.length) {
            await uploadAttachment(expense.id);
          }
          handleSuccess('Expense was updated successfully');
          back(true);
        }).catch(e => handleError(e)).finally(() => {
          editExpenseState.saving = false;
        });
      } else {
        const method = props.stateParams?.methodOverride || props.method || '';
        const body = {
          ...editExpenseState.form,
          method,
          date: editExpenseState.form.date.toNetworkDate()
        };
        if (editExpenseState.costType === 'bill' && !editExpenseState.form.id) {
          body.expenseType = 'bill';
          body.billNumber = editExpenseState.billNumber || undefined;
          body.vendor = {
            id: editExpenseState.vendor.id,
            name: editExpenseState.vendor.displayName || editExpenseState.vendor.name
          };
        }
        if (editExpenseState.costType === 'check' && !editExpenseState.form.id) {
          body.expenseType = 'check';
          body.bankAccountId = editExpenseState.bankAccountId;
          body.printLater = editExpenseState.printLater;
          if (!editExpenseState.printLater && editExpenseState.checkNumber) {
            body.checkNumber = editExpenseState.checkNumber;
          }
          if (editExpenseState.vendor?.id) {
            body.vendor = {
              id: editExpenseState.vendor.id,
              name: editExpenseState.vendor.displayName || editExpenseState.vendor.name
            };
          }
        }
        props.leanLawApi.createMatterExpense({
          id: editExpenseState.form.matter.id,
          body
        }).then(async result => {
          var id = result.id;
          await uploadAttachment(id);
          handleSuccess('Expense was created successfully');
          if (saveAndNew) {
            editExpenseState.form.description = null;
            editExpenseState.form.amount = null;
            editExpenseState.form.standard = null;
            editExpenseState.form.account = null;
            editExpenseState.form.code = null;
            editExpenseState.form.accountingService = null;
            editExpenseState.billNumber = '';
            return;
          }
          back(true);
        }).catch(e => {
          handleError(e);
          editExpenseState.saving = false;
        }).finally(() => {
          editExpenseState.saving = false;
        });
      }
    }
    const showAttachmentPreview = id => {
      editExpenseState.showAttachmentPreview = true;
      editExpenseState.selectedFileIndex = id;
    };
    return (_ctx, _cache) => {
      const _component_v_dialog = _resolveComponent("v-dialog");
      const _component_v_alert = _resolveComponent("v-alert");
      const _component_v_textarea = _resolveComponent("v-textarea");
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_card = _resolveComponent("v-card");
      return _openBlock(), _createBlock(_component_v_card, null, {
        default: _withCtx(() => [_createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [editExpenseState.loading ? (_openBlock(), _createBlock(Loader, {
            key: 0,
            what: 'Expense',
            class: "my-16 px-6"
          })) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_v_dialog, {
            modelValue: editExpenseState.showAttachmentPreview,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => editExpenseState.showAttachmentPreview = $event),
            width: "800"
          }, {
            default: _withCtx(() => [_createVNode(MultipleAttachmentPreview, {
              previewSource: editExpenseState.fileSelector,
              onCancel: _cache[0] || (_cache[0] = $event => editExpenseState.showAttachmentPreview = false),
              selectedFileIndex: editExpenseState.selectedFileIndex
            }, null, 8, ["previewSource", "selectedFileIndex"])]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(LlConfirmationDialog, {
            ref_key: "confirmDialog",
            ref: confirmDialog,
            title: "Delete Confirmation",
            message: editExpenseState.confirmationDialogText
          }, null, 8, ["message"]), _createVNode(_component_v_dialog, {
            modelValue: editExpenseState.showUpgradeToProExpenseAttachmentsModals,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => editExpenseState.showUpgradeToProExpenseAttachmentsModals = $event),
            width: "700"
          }, {
            default: _withCtx(() => [_createVNode(UpgradeToProExpenseAttachmentsModals, {
              routeService: _unref(routeService),
              tracking: __props.tracking,
              onCancel: _cache[2] || (_cache[2] = $event => editExpenseState.showUpgradeToProExpenseAttachmentsModals = false),
              onOpenSupportLink: _cache[3] || (_cache[3] = $event => openSupportLink())
            }, null, 8, ["routeService", "tracking"])]),
            _: 1
          }, 8, ["modelValue"]), editExpenseState.showUploadModal ? (_openBlock(), _createBlock(_component_v_dialog, {
            key: 0,
            modelValue: editExpenseState.showUploadModal,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => editExpenseState.showUploadModal = $event),
            width: "700"
          }, {
            default: _withCtx(() => [_createVNode(AttachmentPicker, {
              showUploadModal: editExpenseState.showAttachmentPicker,
              onClose: _cache[5] || (_cache[5] = $event => editExpenseState.showUploadModal = false),
              onAttachmentSelected: handleSelectedAttachment
            }, null, 8, ["showUploadModal"])]),
            _: 1
          }, 8, ["modelValue"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_createVNode(MainHeader, {
            content: editExpenseState.form.id ? 'Edit Expense' : 'Add Expense'
          }, null, 8, ["content"]), !__props.settlementContext ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_cache[42] || (_cache[42] = _createElementVNode("span", {
            class: "btn btn-small dropdown-toggle",
            "data-toggle": "dropdown"
          }, [_createElementVNode("i", {
            class: "icon-cog"
          }), _createElementVNode("span", {
            class: "caret"
          })], -1)), _createElementVNode("ul", _hoisted_4, [!__props.selectedExpense?.accounting ? (_openBlock(), _createElementBlock("li", _hoisted_5, [_createElementVNode("span", {
            class: "menuitem",
            onClick: _cache[7] || (_cache[7] = $event => createExpenseTemplate('expenses.list.standard'))
          }, [...(_cache[39] || (_cache[39] = [_createElementVNode("i", {
            class: "fa fa-save"
          }, null, -1), _createTextVNode("  Save as Template ", -1)]))])])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("li", null, [_createElementVNode("span", {
            class: "menuitem",
            onClick: _cache[8] || (_cache[8] = $event => markAsBilled())
          }, [...(_cache[40] || (_cache[40] = [_createElementVNode("i", {
            class: "fa fa-usd"
          }, null, -1), _createTextVNode("  Mark as Billed ", -1)]))])], 512), [[_vShow, editExpenseState.form.id && !editExpenseState.form.billed]]), _withDirectives(_createElementVNode("li", null, [_createElementVNode("span", {
            class: "menuitem",
            onClick: _cache[9] || (_cache[9] = $event => deleteExpense())
          }, [_cache[41] || (_cache[41] = _createElementVNode("i", {
            class: "fa fa-trash"
          }, null, -1)), _createTextVNode("  Delete " + _toDisplayString(__props.selectedExpense?.accounting ? ' from LeanLaw' : ''), 1)])], 512), [[_vShow, editExpenseState.form.id && !editExpenseState.form.billed]])])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(editExpenseState.form.billedState === 'Interim' ? 'This Expense is currently in a draft invoice. It can only be edited within the draft.' : 'This Expense was billed and cannot be changed.'), 1)], 512), [[_vShow, editExpenseState.form?.billedState && editExpenseState.form?.billedState !== 'WIP']]), _withDirectives(_createElementVNode("div", _hoisted_9, [_cache[44] || (_cache[44] = _createElementVNode("div", {
            class: "w-8/12 pr-2 text-base"
          }, " This is from QuickBooks and the date and amounts must edited there if necessary. ", -1)), _createElementVNode("div", _hoisted_10, [_createVNode(LlSecondaryButton, {
            onBtnClick: _cache[10] || (_cache[10] = $event => openInQuickbooks())
          }, {
            default: _withCtx(() => [...(_cache[43] || (_cache[43] = [_createElementVNode("img", {
              src: "/img/qb16x16.png"
            }, null, -1), _createTextVNode("   Open in QuickBooks ", -1)]))]),
            _: 1
          })])], 512), [[_vShow, editExpenseState.form.accounting]]), !__props.settlementContext ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(ClientMatterSearch, {
            emitOnAnyChange: true,
            horizontal: true,
            cm: editExpenseState.cm,
            "query-filter": cmQueryFilter.value,
            onMatterChange: _cache[11] || (_cache[11] = $event => matterChanged())
          }, null, 8, ["cm", "query-filter"])])) : _createCommentVNode("", true), !__props.settlementContext && _unref(companySettings).expenses?.standard?.length && !editExpenseState.readonly && !editExpenseState.form.accounting ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(LlSelect, {
            modelValue: editExpenseState.form.standard,
            "onUpdate:modelValue": [_cache[12] || (_cache[12] = $event => editExpenseState.form.standard = $event), _cache[13] || (_cache[13] = $event => selectedStandard())],
            items: _unref(companySettings).expenses.standard,
            "item-title": "label",
            "item-value": "id",
            "data-cy": "template-dropdown",
            "return-object": "",
            placeholder: "Pick an Expense Template",
            label: "Expense Template",
            isAutocomplete: ""
          }, null, 8, ["modelValue", "items"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", {
            class: _normalizeClass(__props.settlementContext ? 'w-full' : 'w-6/12 pr-2')
          }, [editExpenseState.form.accounting ? (_openBlock(), _createBlock(LlTextField, {
            key: 0,
            disabled: true,
            label: "Date",
            placeholder: _ctx.formatDate(editExpenseState.form.date),
            "append-inner-icon": "mdi-calendar-month-outline"
          }, null, 8, ["placeholder"])) : (_openBlock(), _createBlock(LlDatePicker, {
            key: 1,
            modelValue: editExpenseState.form.date,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => editExpenseState.form.date = $event),
            masks: {
              input: 'YYYY-MM-DD'
            },
            disabled: editExpenseState.readonly || editExpenseState.saving,
            showTextField: false,
            "data-cy": "expense-date",
            label: "Date"
          }, null, 8, ["modelValue", "disabled"]))], 2), !__props.settlementContext ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createVNode(LlSelect, {
            modelValue: editExpenseState.form.account,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => editExpenseState.form.account = $event),
            items: editExpenseState.accounts,
            "item-title": "name",
            "item-value": "id",
            "return-object": "",
            placeholder: "No User",
            label: "User",
            "data-cy": "expense-user",
            clearable: "",
            info: "Optional: Can be set if expense is tied to a specific user",
            "show-info": !_unref(companySettings).requireExpenseUser,
            isAutocomplete: ""
          }, null, 8, ["modelValue", "items", "show-info"])])])) : _createCommentVNode("", true)]), !__props.settlementContext && _unref(features).uiHardCostCreation && _unref(permissions).expenses?.createHardCost && (_unref(companySettings).expenses?.sync && !editExpenseState.form.id || editExpenseState.form.id && (editExpenseState.costType === 'bill' || editExpenseState.costType === 'check')) ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(LlSelect, {
            modelValue: editExpenseState.costType,
            "onUpdate:modelValue": [_cache[16] || (_cache[16] = $event => editExpenseState.costType = $event), costTypeChanged],
            label: "Cost Type",
            items: [{
              label: 'Soft cost',
              id: 'soft'
            }, {
              label: 'Hard cost — Bill',
              id: 'bill'
            }, {
              label: 'Hard cost — Check',
              id: 'check'
            }],
            "item-title": "label",
            "item-value": "id",
            "return-object": false,
            "data-cy": "select-cost-type",
            disabled: !!editExpenseState.form.id || editExpenseState.readonly || editExpenseState.saving
          }, null, 8, ["modelValue", "disabled"])])) : _createCommentVNode("", true), !__props.settlementContext && editExpenseState.costType === 'bill' && _unref(features).uiHardCostCreation ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createVNode(LlSelect, {
            modelValue: editExpenseState.vendor,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => editExpenseState.vendor = $event),
            items: editExpenseState.vendors,
            "item-title": item => item.displayName || item.name,
            "item-value": "id",
            "return-object": "",
            placeholder: "Search vendors...",
            label: "Vendor",
            "data-cy": "select-vendor",
            isAutocomplete: "",
            loading: editExpenseState.vendorLoading,
            disabled: !!editExpenseState.form.id || editExpenseState.readonly || editExpenseState.saving
          }, null, 8, ["modelValue", "items", "item-title", "loading", "disabled"]), !editExpenseState.showCreateVendor && !editExpenseState.form.id ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("span", {
            class: "text-sm cursor-pointer text-primary",
            "data-cy": "btn-create-vendor",
            onClick: _cache[18] || (_cache[18] = $event => editExpenseState.showCreateVendor = true)
          }, " + Create vendor ")])) : _createCommentVNode("", true), editExpenseState.showCreateVendor && !editExpenseState.form.id ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createVNode(LlTextField, {
            modelValue: editExpenseState.newVendorName,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => editExpenseState.newVendorName = $event),
            label: "New vendor name",
            placeholder: "Vendor name",
            density: "compact",
            class: "flex-grow"
          }, null, 8, ["modelValue"]), _createVNode(LlSecondaryButton, {
            color: "primary",
            "data-cy": "btn-confirm-create-vendor",
            onBtnClick: _cache[20] || (_cache[20] = $event => createVendor()),
            disabled: !editExpenseState.newVendorName?.trim()
          }, {
            default: _withCtx(() => [...(_cache[45] || (_cache[45] = [_createTextVNode(" Create ", -1)]))]),
            _: 1
          }, 8, ["disabled"]), _createVNode(LlSecondaryButton, {
            onBtnClick: _cache[21] || (_cache[21] = $event => {
              editExpenseState.showCreateVendor = false;
              editExpenseState.newVendorName = '';
            })
          }, {
            default: _withCtx(() => [...(_cache[46] || (_cache[46] = [_createTextVNode(" Cancel ", -1)]))]),
            _: 1
          })]), _cache[47] || (_cache[47] = _createElementVNode("p", {
            class: "text-xs text-gray-500 pt-1"
          }, " Name only — full details can be edited in QuickBooks after creation ", -1))])) : _createCommentVNode("", true)]), !editExpenseState.form.id ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createVNode(LlTextField, {
            modelValue: editExpenseState.billNumber,
            "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => editExpenseState.billNumber = $event),
            label: "Bill number (optional)",
            placeholder: "e.g. INV-88421",
            "data-cy": "input-bill-number",
            density: "compact",
            disabled: !!editExpenseState.form.id || editExpenseState.readonly || editExpenseState.saving
          }, null, 8, ["modelValue", "disabled"]), _cache[48] || (_cache[48] = _createElementVNode("p", {
            class: "text-xs text-gray-500"
          }, "Vendor's bill reference — not a check number", -1))])) : _createCommentVNode("", true), !_unref(companySettings).expenses?.syncAccounts?.length && !editExpenseState.form.id ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createVNode(_component_v_alert, {
            type: "warning",
            density: "compact",
            variant: "tonal"
          }, {
            default: _withCtx(() => [...(_cache[49] || (_cache[49] = [_createTextVNode(" No expense posting account configured — configure in Settings > Integrations > QuickBooks > Expenses. ", -1)]))]),
            _: 1
          })])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), !__props.settlementContext && editExpenseState.costType === 'check' && _unref(features).uiHardCostCreation ? (_openBlock(), _createElementBlock("div", _hoisted_24, [!editExpenseState.form.id ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createVNode(LlSelect, {
            modelValue: editExpenseState.bankAccountId,
            "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => editExpenseState.bankAccountId = $event),
            items: editExpenseState.bankAccounts,
            "item-title": "name",
            "item-value": "id",
            "return-object": false,
            placeholder: "Select a bank account...",
            label: "Bank Account",
            "data-cy": "select-bank-account",
            isAutocomplete: "",
            loading: editExpenseState.bankAccountLoading,
            disabled: editExpenseState.readonly || editExpenseState.saving
          }, null, 8, ["modelValue", "items", "loading", "disabled"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_26, [_createVNode(LlSelect, {
            modelValue: editExpenseState.vendor,
            "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => editExpenseState.vendor = $event),
            items: editExpenseState.vendors,
            "item-title": item => item.displayName || item.name,
            "item-value": "id",
            "return-object": "",
            placeholder: "Search vendors...",
            label: "Payee (optional)",
            info: "Only Vendors will appear here. To pay a client or employee, write the check directly in QuickBooks — it will sync back automatically.",
            "show-info": "",
            isAutocomplete: "",
            clearable: "",
            loading: editExpenseState.vendorLoading,
            disabled: !!editExpenseState.form.id || editExpenseState.readonly || editExpenseState.saving,
            "data-cy": "select-payee"
          }, null, 8, ["modelValue", "items", "item-title", "loading", "disabled"])]), !editExpenseState.printLater ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createVNode(LlTextField, {
            modelValue: editExpenseState.checkNumber,
            "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => editExpenseState.checkNumber = $event),
            label: "Check number (optional)",
            placeholder: "e.g. 1042",
            "data-cy": "input-check-number",
            density: "compact",
            disabled: !!editExpenseState.form.id || editExpenseState.readonly || editExpenseState.saving
          }, null, 8, ["modelValue", "disabled"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_28, [_createVNode(LlCheckbox, {
            modelValue: editExpenseState.printLater,
            "onUpdate:modelValue": printLaterChanged,
            label: "Print this check later",
            "data-cy": "checkbox-print-later",
            disabled: !!editExpenseState.form.id || editExpenseState.readonly || editExpenseState.saving
          }, null, 8, ["modelValue", "disabled"]), _createElementVNode("p", _hoisted_29, _toDisplayString(editExpenseState.printLater ? 'This check will show as pending printing in QuickBooks, with no number assigned yet.' : 'Enter the check number if you already know it, or leave it blank.'), 1)]), !editExpenseState.bankAccounts.length && !editExpenseState.bankAccountLoading && !editExpenseState.form.id ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_createVNode(LlWarningBanner, {
            visible: true
          }, {
            default: _withCtx(() => [...(_cache[50] || (_cache[50] = [_createTextVNode(" No eligible bank account configured — configure one in QuickBooks, or choose a different cost type for now. ", -1)]))]),
            _: 1
          })])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_31, [_createElementVNode("label", _hoisted_32, _toDisplayString(__props.settlementContext ? 'Description' : 'Invoice Description'), 1), _createVNode(_component_v_textarea, {
            modelValue: editExpenseState.form.description,
            "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => editExpenseState.form.description = $event),
            rows: __props.settlementContext ? 2 : 3,
            id: "expense-description",
            "data-cy": "expense-description",
            variant: "outlined",
            onChange: _cache[27] || (_cache[27] = $event => _ctx.okToClearDescription = false),
            disabled: editExpenseState.readonly || editExpenseState.saving
          }, null, 8, ["modelValue", "rows", "disabled"])]), editExpenseState.form.checkNumber && editExpenseState.costType !== 'check' ? (_openBlock(), _createElementBlock("div", _hoisted_33, [_createElementVNode("div", null, [_createVNode(LlTextField, {
            modelValue: editExpenseState.form.checkNumber,
            label: "Check #",
            "data-cy": "expense-check-number",
            disabled: ""
          }, null, 8, ["modelValue"])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createVNode(LlTextField, {
            prefix: '$',
            type: "number",
            label: "Amount",
            id: "expense-amount",
            "data-cy": "expense-amount",
            modelValue: editExpenseState.form.amount,
            "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => editExpenseState.form.amount = $event),
            disabled: editExpenseState.form.accounting || editExpenseState.readonly || editExpenseState.saving
          }, null, 8, ["modelValue", "disabled"])]), _withDirectives(_createElementVNode("div", null, [_createVNode(ExpenseCodePicker, {
            modelValue: editExpenseState.form.code,
            "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => editExpenseState.form.code = $event),
            disabled: editExpenseState.readonly || editExpenseState.saving,
            onCodeChange: checkDescription
          }, null, 8, ["modelValue", "disabled"])], 512), [[_vShow, editExpenseState.form.matter?.client?.codes?.ledes && _unref(companySettings).codes?.ledes]]), _unref(companySettings).labels?.customFlag ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_cache[51] || (_cache[51] = _createElementVNode("label", {
            class: "text-base"
          }, " ", -1)), _createVNode(LlCheckbox, {
            label: _unref(companySettings).labels?.customFlag,
            modelValue: editExpenseState.form.customFlag,
            "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => editExpenseState.form.customFlag = $event),
            disabled: editExpenseState.readonly || editExpenseState.saving
          }, null, 8, ["label", "modelValue", "disabled"])])) : _createCommentVNode("", true)]), !__props.settlementContext ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 6
          }, [_withDirectives(_createElementVNode("div", _hoisted_37, [...(_cache[52] || (_cache[52] = [_createElementVNode("label", null, " Attachments ", -1)]))], 512), [[_vShow, _unref(features).expenseAttachments]]), _withDirectives(_createElementVNode("div", _hoisted_38, [_createVNode(_component_v_icon, {
            class: "mr-2",
            color: "warning"
          }, {
            default: _withCtx(() => [...(_cache[53] || (_cache[53] = [_createTextVNode("mdi-alert", -1)]))]),
            _: 1
          }), _cache[54] || (_cache[54] = _createTextVNode(" This expense was part of a multi-line item in QuickBooks, and attachment syncing is not supported. ", -1))], 512), [[_vShow, editExpenseState.form.isMultiLineExpenseItem && _unref(companySettings).expenses?.syncAttachments]]), _withDirectives(_createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_createElementVNode("div", null, [_withDirectives(_createVNode(LlSecondaryButton, {
            onBtnClick: _cache[31] || (_cache[31] = $event => handelAddReceptClick())
          }, {
            default: _withCtx(() => [_createVNode(_component_v_icon, null, {
              default: _withCtx(() => [...(_cache[55] || (_cache[55] = [_createTextVNode("mdi-paperclip", -1)]))]),
              _: 1
            }), _cache[56] || (_cache[56] = _createTextVNode(" Add Attachments ", -1))]),
            _: 1
          }, 512), [[_vShow, _unref(permissions)?.expenses?.create]])]), _unref(permissions)?.expenses?.create ? (_openBlock(), _createElementBlock("div", _hoisted_41, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editExpenseState.fileSelector, (file, id) => {
            return _openBlock(), _createElementBlock("div", {
              key: id
            }, [_createElementVNode("div", _hoisted_42, [_createVNode(FileChip, {
              file: file,
              onDelete: handelDeleteAttachment,
              onPreview: $event => showAttachmentPreview(id)
            }, null, 8, ["file", "onPreview"])])]);
          }), 128))])) : _createCommentVNode("", true)])], 512), [[_vShow, _unref(features).expenseAttachments]])], 64)) : _createCommentVNode("", true), __props.settlementContext ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 7
          }, [_createElementVNode("div", _hoisted_43, [_createElementVNode("a", {
            href: "#",
            class: "text-body-2 text-primary",
            "data-cy": "open-on-expenses-page",
            onClick: _cache[32] || (_cache[32] = _withModifiers($event => _ctx.$emit('navigate-to-expenses', editExpenseState.form.id || null), ["prevent"]))
          }, " Open on Expenses page → ")]), _createElementVNode("div", _hoisted_44, [_createVNode(LlSecondaryButton, {
            onBtnClick: _cache[33] || (_cache[33] = $event => back(false))
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(editExpenseState.readonly ? 'Done' : 'Cancel'), 1)]),
            _: 1
          }), _createVNode(LlSecondaryButton, {
            color: "primary",
            variant: "flat",
            onBtnClick: _cache[34] || (_cache[34] = $event => save()),
            id: "save-expense-button",
            "data-cy": "save-expense",
            disabled: editExpenseState.loading || editExpenseState.saving
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("i", _hoisted_45, null, 512), [[_vShow, editExpenseState.saving]]), _cache[57] || (_cache[57] = _createElementVNode("span", null, "Save", -1))]),
            _: 1
          }, 8, ["disabled"])])], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_withDirectives(_createElementVNode("div", _hoisted_48, [_createVNode(LlSecondaryButton, {
            color: "error",
            variant: "flat",
            onBtnClick: _cache[35] || (_cache[35] = $event => deleteExpense()),
            id: "delete-expense-button"
          }, {
            default: _withCtx(() => [_createVNode(_component_v_icon, null, {
              default: _withCtx(() => [...(_cache[58] || (_cache[58] = [_createTextVNode("mdi-trash-can-outline", -1)]))]),
              _: 1
            }), _createTextVNode("Delete " + _toDisplayString(editExpenseState.form.accounting ? ' from LeanLaw' : ''), 1)]),
            _: 1
          })], 512), [[_vShow, editExpenseState.form.id && !editExpenseState.form.billed && !editExpenseState.readonly]]), _createVNode(LlSecondaryButton, {
            onBtnClick: _cache[36] || (_cache[36] = $event => back(false))
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(editExpenseState.readonly ? 'Done' : 'Cancel'), 1)]),
            _: 1
          })]), _createElementVNode("div", _hoisted_49, [_withDirectives(_createElementVNode("div", _hoisted_50, [_createVNode(LlSecondaryButton, {
            color: "primary",
            variant: "flat",
            onBtnClick: _cache[37] || (_cache[37] = $event => save(true)),
            id: "savenew-expense-button",
            "data-cy": "save-and-new",
            disabled: editExpenseState.loading || editExpenseState.saving
          }, {
            default: _withCtx(() => [...(_cache[59] || (_cache[59] = [_createTextVNode(" Save and New ", -1)]))]),
            _: 1
          }, 8, ["disabled"])], 512), [[_vShow, !editExpenseState.form.id]]), _createElementVNode("div", null, [_createVNode(LlSecondaryButton, {
            color: "primary",
            variant: "flat",
            onBtnClick: _cache[38] || (_cache[38] = $event => save()),
            id: "save-expense-button",
            "data-cy": "save-expense",
            disabled: editExpenseState.loading || editExpenseState.saving
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("i", _hoisted_51, null, 512), [[_vShow, editExpenseState.saving]]), _cache[60] || (_cache[60] = _createElementVNode("span", null, "Save", -1))]),
            _: 1
          }, 8, ["disabled"])])])]))])]))]),
          _: 1
        })]),
        _: 1
      });
    };
  }
});